import { Link } from "react-router-dom";
import { CheckCircle2, Lock } from "lucide-react";
import { imgUrl, inr } from "@/lib/api";

export const PackageCard = ({ pkg, index = 0, action }) => (
  <div className="fade-up flex flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white transition-shadow hover:shadow-xl" style={{ animationDelay: `${index * 60}ms` }} data-testid={`package-card-${index}`}>
    <div className="relative aspect-[16/9] overflow-hidden bg-slate-100">
      <img src={imgUrl(pkg.image)} alt={pkg.name} className="h-full w-full object-cover" />
      <span className="absolute left-3 top-3 rounded-full bg-slate-950/80 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white backdrop-blur">{pkg.name}</span>
    </div>
    <div className="flex flex-1 flex-col gap-4 p-5">
      <div className="flex items-baseline justify-between gap-2">
        <h3 className="font-display text-lg font-bold">{pkg.name}</h3>
        <p className="font-mono-num text-2xl font-extrabold text-amber-600" data-testid={`package-price-${index}`}>{inr(pkg.price)}</p>
      </div>
      <p className="text-sm text-slate-600">{pkg.description}</p>
      <ul className="space-y-1.5 text-sm">
        {pkg.items.map((it) => (
          <li key={it.product_name} className="flex items-start gap-2"><CheckCircle2 className="mt-0.5 h-4 w-4 shrink-0 text-emerald-600" /><span>{it.product_name} <span className="text-slate-500">· {it.quantity || "quantity to be confirmed"}</span></span></li>
        ))}
      </ul>
      <div className="mt-auto pt-2">
        {action || (
          <Link to="/member" className="inline-flex w-full items-center justify-center gap-2 rounded-full border border-slate-300 px-5 py-2.5 text-sm font-semibold text-slate-700 transition-colors hover:border-slate-900" data-testid={`package-distributor-login-${index}`}>
            <Lock className="h-4 w-4" /> Ordered by approved distributors from their dashboard
          </Link>
        )}
      </div>
    </div>
  </div>
);

export const ComplianceNote = ({ className = "" }) => (
  <p className={`rounded-xl border border-amber-200 bg-amber-50 p-4 text-xs leading-relaxed text-amber-900 ${className}`} data-testid="mlm-compliance-note">
    Joining as a distributor is free and no package purchase is required. Packages of genuine BMI SP GROUP products can be ordered only by approved distributors from the Distributor Dashboard. Commissions, if enabled, are earned only on genuine, verified product sales — never for registration or recruitment. BMI SP GROUP does not guarantee any income.
  </p>
);
